<script setup lang="ts">
import { ChevronUpIcon } from '@heroicons/vue/24/outline';
import type { IElement } from '~/interfaces/form/formBuilder';

const props = defineProps<{
  element: IElement;
  formErrors: { [key: string]: string };
  open?: boolean;
  dropdownLabel?: string;
}>();

const { toggleReferralInputActive, isReferralInputActive } =
  useRegistrationState();
const isOpen = ref<boolean>(props.open ?? false);
const model = defineModel<string>();
const isReferralInput = computed(() => props.element.id === 'referralCode');
const toggleDropDown = () => {
  if (isReferralInput.value) toggleReferralInputActive();
  else isOpen.value = !isOpen.value;
};
const boolToUse = computed(() =>
  isReferralInput.value ? isReferralInputActive.value : isOpen.value,
);
const handleBlur = () => {
  if (props.formErrors[props.element.id]) {
    if (!model.value) delete props.formErrors[props.element.id];
  }
};
</script>

<template>
  <div class="relative">
    <div
      class="bg-base text-base-priority flex justify-between items-center w-full mb-2 p-3 pr-4 cursor-pointer input-style stacked-border rounded-lg relative z-10 transition duration-300"
      @click="toggleDropDown"
    >
      {{ $t(isReferralInput ? 'have-signup-code' : dropdownLabel) }}
      <component
        :is="ChevronUpIcon"
        :key="boolToUse.toString()"
        :class="[
          'w-4 text-dark-700/60 dark:text-light-50/50 font-bold',
          { 'rotate-0': boolToUse, 'rotate-180': !boolToUse },
        ]"
      />
    </div>
    <div
      :class="{
        'absolute top-0 left-0 w-full z-[0] transition duration-300':
          !boolToUse,
        block: boolToUse,
      }"
    >
      <UserInterfaceDynamicFormBuilderInput
        v-model="model"
        :element="element"
        :form-errors="formErrors"
        @input-blur="handleBlur"
      />
    </div>
  </div>
</template>
